import { getStoredUser, getUserToken } from "../../functions/themeAssets";

const base = () => process.env.REACT_APP_BACKEND_URL;

async function post(path, body) {
  const user = getStoredUser();
  const res = await fetch(`${base()}/${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${getUserToken(user)}` },
    body: JSON.stringify(body),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.success === false) throw new Error(json.message || "Request failed");
  return json;
}

const who = (user) => ({
  userId: user.userId,
  name: user.name,
  email: user.email,
  role: user.role || user.source,
});

/** Theme + progress (+ the content of `stage`, 1-4, when the player is on it). */
export const getGameData = (user, stage) => post("getGameData", { ...who(user), stage });

/** Store the result of one challenge; the server works out the points. */
export const saveChallenge = (user, stage, payload) =>
  post("saveChallenge", { userId: user.userId, stage, ...payload });

export const saveReportId = (user, reportId) => post("setReportId", { userId: user.userId, reportId });

/** Where each stage lives; 5 = finished. */
export const STAGE_PATHS = {
  1: "/think-fast",
  2: "/think-simple",
  3: "/think-closer",
  4: "/puzzle-game",
  5: "/thankyou",
};
